export function convertNavObjToArr(obj) {
  if (obj == null) return [];

  const arr = [];
  let i = 0;
  while (i < 5) {
    i++;
    const title = obj[`link${i}_txt`];
    if (title) {
      arr.push({
        title,
        desc: obj[`link${i}_desc`],
        link: obj[`link${i}_url`],
        icon: obj[`link${i}_icon`]
      });
    }
  }
  return arr;
}
/**
 * @param {string} url
 * @returns {boolean}
 */
export function isSameWebsite(url) {
  if (!url) return false;
  const newUrl = new URL(url);
  return newUrl.origin === window.location.origin && newUrl.pathname === window.location.pathname;
}
